import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import HiclassTV from "./HiclassTV";
// import jQuery from "jquery";

import "./locales/config";

/* Pbl 관련 */
import * as pblSendHelper from "./lib/helper/rbmq/RbmqPblSendHelper";
import * as pblRcvHelper from "./lib/helper/rbmq/RbmqPblRcvHelper";
import * as pblMediaHelper from "./lib/helper/MediaSoupPblHelper";
import * as pblActionResultHelper from "./lib/helper/ActionResultPblHelper";

/* 안드로이드 Pro앱 관련 */
import "./lib/helper/AndroidWebViewHelper";

/* 20261019 web-relay phase0 개발 조건(IS_DEV_VALUE) 확인용. 부수 효과 없는 상수 모듈 */
import ConstData from "./lib/ConstData";
import { getLandingBaseUrl, LANDING_CACHE_KEY } from "./lib/LandingPath";   // 20261105 디자이너 파일 경로

/* 20261105 디자이너용 헤더(메뉴바) 스타일({landing}/css/header.css)을 앱 CSS 뒤에 로드
   - 로그인 전/후, 관리자 화면의 헤더에 공통 적용 (빌드 없이 수정 가능)
   - 캐시 때문에 수정이 늦게 반영되지 않도록 앱을 열 때마다 새로 받도록 시간값을 붙임 (로컬 서버는 클라우드 파일 사용)
   - 파일이 없거나 USE_LANDING_HTML 이 false 면 기존 스타일 그대로 */
if (ConstData.USE_LANDING_HTML) {
  try {
    const headerStyleLink = document.createElement("link");
    headerStyleLink.rel = "stylesheet";
    headerStyleLink.href = getLandingBaseUrl() + "css/header.css?t=" + LANDING_CACHE_KEY;
    document.head.appendChild(headerStyleLink);
  } catch (e) {
    console.log("index.js - load landing header.css err => ", e);
  }
}

/* 20261105 테스트/개발 서버(IS_DEV_VALUE)면 <html data-hc-dev="Y"> 표시
   - 디자이너가 header.css 에서 html[data-hc-dev="Y"] 로 테스트 서버 전용 스타일을 지정할 수 있음 (리얼 서버에는 붙지 않음) */
if (ConstData.USE_LANDING_HTML && ConstData.IS_DEV_VALUE && document.documentElement) {
  document.documentElement.setAttribute("data-hc-dev", "Y");
}

const applyPentalkThemeMode = mode => {
  const normalized = ["dark", "soft-dark", "light"].includes(mode) ? mode : "dark";
  try {
    window.__PENTALK_THEME_MODE = normalized;
    window.localStorage.setItem("PENTALK_THEME_MODE", normalized);
  } catch (e) {}

  if (document.documentElement) {
    document.documentElement.setAttribute("data-pentalk-theme", normalized);
  }
  if (document.body) {
    document.body.setAttribute("data-pentalk-theme", normalized);
  }
};

try {
  applyPentalkThemeMode(window.localStorage.getItem("PENTALK_THEME_MODE") || "dark");
} catch (e) {
  applyPentalkThemeMode("dark");
}

window.PentalkApplyThemeMode = applyPentalkThemeMode;
window.addEventListener("pentalk-theme-change", event => {
  if (event && event.detail && event.detail.mode) {
    applyPentalkThemeMode(event.detail.mode);
  }
});


var hiclasstv = ReactDOM.render(React.createElement(HiclassTV), document.getElementById("root"));
// console.log(hiclasstv);
window.hiclasstv = hiclasstv;
window.sendRawDataWithRoutinKey = hiclasstv.sendRawDataWithRoutinKey;
window.sendedDataFromHiClass = hiclasstv.sendedDataFromHiClass;
window.sendWhisperData = hiclasstv.sendWhisperData;

// 20261019 web-relay phase0 개발 하네스: 개발 버전(IS_DEV_VALUE) + 앱 relay 브리지가 있을 때만 별도 청크를 불러온다.
// 실서버 빌드·구버전 앱·앱 개발 설정 off 에서는 실행되지 않는다.
if (ConstData.IS_DEV_VALUE && window.PentalkRelay) {
  import("./lib/relay/PentalkRelayHarness")
    .then(m => m.install())
    .catch(e => console.log("[PentalkRelay] harness load fail", e));
}
// window.Kakao.init("dc9610043a925d57af30398314d3c552");
// window.$ = window.jQuery= jQuery;

window.pblSendHelper = pblSendHelper;
window.pblRcvHelper = pblRcvHelper;
window.pblMediaHelper = pblMediaHelper;
window.pblActionResultHelper = pblActionResultHelper;

serviceWorker.unregister();